// extracted by mini-css-extract-plugin
module.exports = {"templateWrapper":"styles_templateWrapper__1XIcl","mainWrapper":"styles_mainWrapper__1LdBV","content":"styles_content__3b0Rj"};